<template>
  <transition name="fade">
    <div class="c-header-search-window-mobile">
      <div class="c-header-search-window-mobile__close">
        <i class="icon-x" @click="$emit('close-clicked')"></i>
      </div>

      <h3 class="c-header-search-window-mobile__title-1">アイテム検索</h3>
      <div class="c-header-search-window-mobile__search-input">
        <search-input
          :placeholder="placeholder"
          :value="searchKeyword"
          @search-keyword-changed="$emit('search-keyword-changed', $event)"
          @search-keyword-input="$emit('search-keyword-input', $event)"
          @search-input-entered="$emit('search-input-entered', $event)"
          size="small"
        ></search-input>
      </div>
      <div v-show="collectionItems.length">
        <h4 class="c-header-search-window-mobile__title-2">
          カテゴリ・コレクション
        </h4>
        <ul class="c-header-search-window-mobile__linkItems">
          <li
            v-for="collectionItem in collectionItems"
            :key="collectionItem.id"
            class="c-header-search-window-mobile__collectionItem"
          >
            <a
              :href="collectionItem.url"
              class="c-header-search-window-mobile__link"
            >
              {{ collectionItem.title }}
            </a>
          </li>
        </ul>
      </div>

      <div v-show="articleItems.length">
        <h4 class="c-header-search-window-mobile__title-2">
          特集・コーディネート
        </h4>
        <ul class="c-header-search-window-mobile__linkItems">
          <li
            v-for="articleItem in articleItems"
            :key="articleItem.id"
            class="c-header-search-window-mobile__linkItem"
          >
            <header-link-card
              :link-item="articleItem"
              :mark-word="markWord"
            ></header-link-card>
          </li>
        </ul>
      </div>

      <div v-show="recentSearches.length">
        <h4 class="c-header-search-window-mobile__title-2">検索履歴から探す</h4>
        <ul class="c-header-search-window-mobile__recent-searches">
          <li
            class="c-header-search-window-mobile__recent-search"
            v-for="recentSearch in recentSearches"
            :key="recentSearch"
          >
            <header-link
              deletable
              :link-item="recentSearch"
              icon-name="clock"
              :mark-word="markWord"
              @delete-clicked="$emit('delete-clicked', recentSearch)"
            ></header-link>
          </li>
        </ul>
      </div>

      <div v-show="querySuggestions.length">
        <h4 class="c-header-search-window-mobile__title-2">
          人気検索キーワードから探す
        </h4>
        <ul class="c-header-search-window-mobile__query-suggestions">
          <li
            class="c-header-search-window-mobile__query-suggestion"
            v-for="querySuggestion in querySuggestions"
            :key="querySuggestion"
          >
            <header-link
              :link-item="querySuggestion"
              icon-name="search"
              :mark-word="markWord"
            ></header-link>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import HeaderLink from '~/js/components/header/link'
import HeaderLinkCard from '~/js/components/header/linkCard'
import FProductCard from '~/js/components/productCard'
import SearchInput from '~/js/components/header/searchInput'

export default {
  name: 'ComponentHeaderSearchWindowMobile',
  components: {
    HeaderLink,
    HeaderLinkCard,
    FProductCard,
    SearchInput,
  },
  props: {
    articleItems: { type: Array, default: () => [] },
    collectionItems: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    querySuggestions: { type: Array, default: () => [] },
    recentSearches: { type: Array, default: () => [] },
    products: { type: Array, default: () => [] },
    searchKeyword: { type: String, default: '' },
    markWord: { type: String, default: '' },
  },
}
</script>
<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-header-search-window-mobile {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  padding: 24px;
  background-color: variables.$color-pink;
  z-index: variables.$z-index-header + 1;
  transition: opacity 0.3s;
  overflow: scroll;

  &__close {
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
  }

  &__title-1 {
    font-size: 20px;
    font-weight: 600;
    margin-top: 16px;
  }

  &__title-2 {
    font-weight: 600;
    font-size: 16px;
  }

  &__search-input {
    margin: 20px 0 48px;
  }

  &__recent-searches,
  &__query-suggestions,
  &__products,
  &__linkItems,
  &__text {
    margin: 16px 0 40px;
  }

  &__recent-search,
  &__query-suggestion {
    margin: 4px 0;
  }

  &__products {
    display: flex;
    overflow-x: scroll;
    margin-right: -24px;
    margin-left: -24px;
  }

  &__product {
    width: variables.$width-product-card-default;
    margin-left: 20px;

    &:first-child {
      margin-left: 24px;
    }

    &:last-child {
      margin-right: 24px;
    }
  }

  &__linkItems {
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
  }

  &__linkItem {
    & + & {
      margin-top: 30px;
    }
  }

  &__collectionItem {
    & + & {
      margin-top: 16px;
    }
  }

  &__link {
    display: block;
    font-weight: 600;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    :deep(em) {
      background-color: variables.$color-pink;
      padding: 2px;
    }
  }

  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
